import React, { Component } from "react";
import { Link } from 'react-router-dom';
import ReactDOM from "react-dom";
import BootstrapTable from "react-bootstrap-table-next";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import "./styles.css";
import { Button } from "react-bootstrap";

import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HowItWorksImg from "./../Images/how-it-works.png";
import { FaChevronRight } from "react-icons/fa";

const products = [
  { id: 1, OrderNo:1, Plots: "Proprietorship Firm",  EmiAccount: "lorem ispum",  NoOfEmis: "2",  Withdrawal: "2" },
  { id: 2, OrderNo:2, Plots: "Proprietorship Firm",  EmiAccount: "lorem ispum",  NoOfEmis: "2",  Withdrawal: "2" },
  { id: 3, OrderNo:3, Plots: "Proprietorship Firm",  EmiAccount: "lorem ispum",  NoOfEmis: "2",  Withdrawal: "2" },
  { id: 4, OrderNo:4, Plots: "Proprietorship Firm",  EmiAccount: "lorem ispum",  NoOfEmis: "2",  Withdrawal: "2" }
];

class OrdersHistory extends Component {
  constructor() {
    super();
    this.state = {
      // For displaying data
      columns: [
        {
          dataField: "id",
          text: "Serial Number",
          sort: true
        },
        {
          dataField: "OrderNo",
          text: "Order No",
          sort: true
        },
        {
          dataField: "Plots",
          text: "Plots"
        },
        {
          dataField: "EmiAccount",
          text: "Emi Account"
        },
        {
          dataField: "NoOfEmis",
          text: "No Of Emi"
        },
        {
          dataField: "Withdrawal",
          text: "Withdrawal"
        },
        {
          dataField: "Payment Status",
          text: "Payment Status",
          formatter: this.linkFollow,
          sort: true
        },
        // {
        //   dataField: "Delivery Report",
        //   text: "Delivery Report",
        //   formatter: this.linkFollow2,
        //   sort: true
        // }
      ],
      isFollow: true
    };

    this.onFollowChanged.bind(this);
  }

  onFollowChanged() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
        <span className="status dark-span bg-dark">Pending</span>
     
     </>
    );
  };
  onFollowChanged2() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  linkFollow2 = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
        
        
      <Button className="file-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i class="fa-solid fa-file"></i>
      </Button>
       <Button className="file-btn"
       onClick={() => {
         this.onFollowChanged2(row);
       }}
     >
       <i class="bi bi-file-earmark-bar-graph-fill"></i>
     </Button>
     <Button className="file-btn"
       onClick={() => {
         this.onFollowChanged2(row);
       }}
     >
      <i class="bi bi-file-earmark-check-fill"></i>
     </Button>
     </>
    );
  };

  render() {
    return (
        <>
    
    <Header/>
    
    <div
                className="banner w-100"
                style={{ backgroundImage: `url(${HowItWorksImg})` }}
            >
                <div className="container">
                    <div className="banner-title text-center">
                        <h1>Order History</h1>
                        <p>
                            <Link to="/">Home</Link>{" "}
                            <span>
                                <FaChevronRight />
                            </span>{" "}
                            Order History
                        </p>
                    </div>
                </div>
            </div>
        <div>
          
            {/* Accounting-Services */}
          
      <div style={{ padding: "60px 0px" }} className="bg-white">
        <div className="container">
     
        <BootstrapTable
        insertRow
        deleteRow={true}
        responsive={true}
          keyField="id"
          striped={true}
          className="text-center"
          data={products}
          columns={this.state.columns}
        />
        </div>
      </div>
      </div>
      <Footer/>
      </>
    );
  }
}


export default OrdersHistory;